/**
 * Laedt einen reinen Base64-PDF-String (OHNE `data:`-Praefix, wie ihn der Server
 * z. B. ueber `downloadCertificate` liefert) als Datei herunter.
 *
 * Erzeugt einen Blob (application/pdf), startet den Download ueber einen
 * temporaeren `<a download>`-Link und gibt die Object-URL anschliessend wieder
 * frei. Node-14-/Browser-kompatibel (kein Buffer, keine modernen APIs).
 *
 * Hinweis: NICHT den `data:application/pdf;base64,`-Praefix voranstellen — das
 * ist nur fuer die iframe-Vorschau noetig, fuer den Blob-Download wuerde es das
 * PDF beschaedigen.
 */
export const downloadPdfFromBase64 = (base64: string, fileName: string): void => {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);

    for (let i = 0; i < len; i += 1) {
        bytes[i] = binaryString.charCodeAt(i);
    }

    const blob = new Blob([bytes], {type: "application/pdf"});
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
};
